import { useEffect, useState } from "react";

import useUserStore from "@store/useUserStore";
import useSystemStore from "@store/useSystemStore";
import usePlatformStore from "@store/usePlatformStore";
import { useTheme } from "@hooks/useTheme";
import { useUserpilot } from "@platform/hooks/useUserpilot";
import { useConnection } from "@hooks/useConnection";
import { useNetworkStatus } from "@hooks/useNetworkStatus";
import { usePlatformItem } from "@hooks/usePlatformItem";
import { ActiveScreenManager, ItemType } from "@enums/common.enum";
import MainLayout from "@components/Layouts/MainLayout";
import {
  EmailScreenManager,
  MeetingScreenManager,
  ChromeScreenManager,
} from "@components/ScreenManager";
import { AppToaster } from "@ui/AppToaster/AppToaster";
import { TransitionWrapper } from "@ui/Transition";
import { GlobalDialog } from "@ui/Dialogs";
import { SideBlade } from "@ui/SideBlade";

const SCREEN_COMPONENTS = {
  [ActiveScreenManager.CHROME]: ChromeScreenManager,
  [ActiveScreenManager.EMAIL]: EmailScreenManager,
  [ActiveScreenManager.MEETING]: MeetingScreenManager,
} as const;

export default function MainScreenManager() {
  const { hasSession } = useUserStore();
  const { itemType } = usePlatformStore();
  const { isAppLoading } = useSystemStore();
  const [activeScreenManager, setActiveScreenManager] = useState(ActiveScreenManager.CHROME);

  useTheme();
  useUserpilot();
  useConnection();
  usePlatformItem();
  useNetworkStatus();

  useEffect(() => {
    if (hasSession && itemType === ItemType.EMAIL) {
      setActiveScreenManager(ActiveScreenManager.EMAIL);
    } else if (hasSession && itemType === ItemType.MEETING) {
      setActiveScreenManager(ActiveScreenManager.MEETING);
    } else {
      setActiveScreenManager(ActiveScreenManager.CHROME);
    }
  }, [hasSession, itemType]);

  const ScreenComponent = SCREEN_COMPONENTS[activeScreenManager];

  return (
    <MainLayout>
      <AppToaster />
      <GlobalDialog />
      <SideBlade />

      <TransitionWrapper screenKey={activeScreenManager} disableTransition={isAppLoading}>
        <ScreenComponent />
      </TransitionWrapper>
    </MainLayout>
  );
}
